//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/BasePart.js";
let d=[[[0,"Workplane",0,"Preferences.WorkPlane",0]],[],[["Modeling","Preferences.PartModeling",0],["Drafting","Preferences.PartDrafting",0],["ObjectPreferences","Preferences.PartObject",0],["UserInterface","Preferences.PartUserInterface",0],["VisualVisualization","Preferences.PartVisualizationVisual",0],["LineVisualization","Preferences.PartVisualizationLine",0],["NamesBorderVisualization","Preferences.PartVisualizationNamesBorders",0],["ColorSettingVisualization","Preferences.PartVisualizationColorSetting",0],["ShadeVisualization","Preferences.PartVisualizationShade",0],["PartSheetmetal","Preferences.PartSheetmetal",1],["PartFlexiblePrintedCircuitDesign","Preferences.PartFlexiblePrintedCircuitDesign",1],["PartAeroSheetmetal","Preferences.PartAeroSheetmetal",0],["PartSketch","Preferences.PartSketch",0],["DraftingPreference","Preferences.DraftingPreferenceManager",0],["EmphasisVisualization","Preferences.PartVisualizationEmphasis",0],["PerformanceVisualization","Preferences.PartVisualizationPerformance",0],["ScreenVisualization","Preferences.PartVisualizationScreen",0],["AppearanceMgmtPreference","Preferences.PartAppearanceMgrPreference",0],["SheetMetalPreferences","Preferences.SheetMetalPreferencesManager",0],["FpcdPreferences","Preferences.FpcdPreferencesManager",0]]];
SPLM.Preferences.PartPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;